import { editorViewState, viewState } from '../state/view-state.js';

/**
 * @typedef {import('../types/jsdoc-types.js').ReactiveControllerHost} ReactiveControllerHost
 */

export class ViewStateController {
  /**
   * @param {ReactiveControllerHost} host
   * @param {{ isEditor?: boolean, onChange?: (() => void) }} [options]
   */
  constructor(host, options = {}) {
    this.host = host;
    this._isEditor = options.isEditor || false;
    this._onChange = options.onChange || null;
    this._unsubscribe = null;
    host.addController(this);
  }

  get state() {
    return this._isEditor ? editorViewState : viewState;
  }

  hostConnected() {
    this._unsubscribe = this.state.subscribe(() => {
      this._onChange?.();
      this.host.requestUpdate();
    });
  }

  hostDisconnected() {
    this._unsubscribe?.();
    this._unsubscribe = null;
  }
}
